export default __webpack_public_path__ + "static/media/22-twilight.d514d449.png";